module.exports = __webpack_public_path__ + "static/media/transformed-hands-in.1ba6ae58.jpg";